<!--
 * @Author: gongzhichao 18311120024@163.com
 * @Date: 2023-05-25 19:05:44
 * @LastEditors: gongzhichao 18311120024@163.com
 * @LastEditTime: 2024-04-29 10:57:26
 * @FilePath: \jyrg-web\src\components\mobile\Layout\Layout.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class='content'>
    <Header></Header>
    <keep-alive include='Home'>
      <router-view></router-view>
    </keep-alive>
    <!-- <Footer></Footer>/ -->
    <VoucherIndexCenter style='z-index: 9999;' :show='topUpShow' @close='close(false)'></VoucherIndexCenter>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import Header from '../Header/index.vue';
import VoucherIndexCenter from '../../public/VoucherIndexCenter/index.vue';


export default {
  computed: {
    ...mapGetters({ topUpShow: 'base/topUpShow' }),
  },
  components: { Header, VoucherIndexCenter },
};
</script>
